import { useAtomValue, useSetAtom } from 'jotai';

import { ToggleButton } from '@ekhodealer/ekho-common/rev';

import { actionRequiredFilterAtom, updateActionRequiredFilterAtom } from '../../atoms/ordersAtoms';
import { useActionRequiredCount } from '../../hooks/useActionRequiredCount';

/**
 * FiltersDrawerActionRequiredSection component that provides a toggle
 * for filtering orders by action required status
 */
export function FiltersDrawerActionRequiredSection() {
	const actionRequiredCount = useActionRequiredCount();
	const actionRequiredFilter = useAtomValue(actionRequiredFilterAtom);
	const updateActionRequiredFilter = useSetAtom(updateActionRequiredFilterAtom);

	const handleToggle = (isSelected: boolean) => {
		updateActionRequiredFilter(isSelected);
	};

	return (
		<ToggleButton
			variant='outline'
			selectedVariant='filled'
			size='large'
			rounding='full'
			isSelected={actionRequiredFilter}
			onChange={handleToggle}>
			Action required {actionRequiredCount}
		</ToggleButton>
	);
}
